const prefix = 'nxt';
const iconName = 'callTransfer';
const width = 21;
const height = 21;
const ligatures = [];
const unicode = '';
const svgPathData =
  'M17.96 13.621l-3.784-1.596a1.773 1.773 0 00-.668-.148c-.52 0-1.002.26-1.299.63l-1.225 1.485a11.444 11.444 0 01-4.601-4.601l1.484-1.225c.371-.297.631-.78.631-1.299 0-.26-.074-.482-.148-.668L6.754 2.414a1.77 1.77 0 00-1.596-1.039c-.111 0-.222.037-.37.074l-3.49.78A1.715 1.715 0 000 3.899c0 9.128 7.385 16.513 16.477 16.476.816 0 1.484-.557 1.67-1.299l.779-3.488c.037-.148.074-.26.074-.371a1.77 1.77 0 00-1.04-1.596zm-1.558 5.01C8.35 18.594 1.818 12.025 1.782 3.973l3.34-.78L6.68 6.83 4.156 8.908c1.744 3.674 3.637 5.567 7.31 7.31l2.079-2.523 3.637 1.559-.78 3.377zM12.125 5.188c0 .273.195.468.469.468H16.5v2.032c0 .43.488.625.8.332l3.438-3.438a.484.484 0 000-.664L17.301.5C16.988.207 16.5.402 16.5.832v2.012h-3.906a.463.463 0 00-.469.469v1.874z';

const definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData],
};

const nxtCallTransfer = definition;

export { definition, nxtCallTransfer, prefix, iconName, width, height, ligatures, unicode, svgPathData };
